import styled from 'styled-components';

interface IconProps {
  height?: number;
  marginRight?: number;
}

export const Icon = styled.i<IconProps>`
  display: inline-block;
  height: ${(props) => (props.height ? props.height : '1')}em; /* default icon height */
  position: relative;
  user-select: none;
  vertical-align: middle;
  margin-right: ${(props) => (props.marginRight ? props.marginRight : '14')}px;

  & > div > div {
    line-height: 0;
  }

  div,
  svg {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }

  canvas {
    display: block;
    height: 100%;
    width: 100%;
    visibility: hidden;
  }
`;
